// TT-291: keep Meta in step with the OneTrust Targeting choice, on load and on every change.

import {
  clearAttribution,
  commitPendingAttribution,
  hasAnsweredConsent,
  hasTargetingConsent,
  onConsentChange,
} from '@repo/utils';

import { setMetaPixelConsent } from '../metaPixel';

const META_COOKIES = ['_fbp', '_fbc'];

let started = false;

function deleteMetaCookies(): void {
  META_COOKIES.forEach((name) => {
    // Meta sets them on the root domain; also clear a host only copy (local, preview hosts)
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.pfida.com`;
    document.cookie = `${name}=; Max-Age=0; path=/`;
  });
}

function apply(targeting: boolean): void {
  try {
    setMetaPixelConsent(targeting);
    if (targeting) {
      // the campaign seen before the yes reaches the device only now (Legal, 5 October 2026)
      commitPendingAttribution();
      return;
    }
    // an answered "no" removes every trace (FR-4)
    if (hasAnsweredConsent()) {
      clearAttribution();
      deleteMetaCookies();
    }
  } catch {
    // consent must never break the app
  }
}

/** Applies the current choice, then follows changes. Starts once; returns a stop. */
export function startConsentBridge(): () => void {
  if (started) {
    return () => {};
  }
  started = true;
  apply(hasTargetingConsent());
  const unsubscribe = onConsentChange(apply);
  return () => {
    unsubscribe();
    started = false;
  };
}
